<template>
	<div class="sign-in-form-container">
		<div class="sign-in-form-title">
			<button @click="redirectTo('/', 'stretch')">
				<img src="@/common/assets/images/icon-left.webp" alt="back">
			</button>
			<h2>Sign in as a Guest</h2>
		</div>
		<form class="sign-in-form" @submit="(event) => handleSubmit(event)">

			<div class="sign-in-form-content">
				<label for="email">Email:</label>
				<input
					ref="email"
					type="email"
					id="email"
					name="email"
					v-model="formData.username"
					placeholder="Enter your email"
					autocomplete="email"
					required
					@focusout="FORM_VALIDATOR?.validateFormField('username')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('username')}]"
				>
			</div>

			<div class="sign-in-form-content">
				<label for="password">Password:</label>
				<input
					ref="password"
					type="password"
					id="password"
					name="password"
					v-model="formData.password"
					placeholder="Enter your password"
					autocomplete="password"
					required
					@focusout="FORM_VALIDATOR?.validateFormField('password')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('password')}]"
				>

				<span class="toggle-password" @click="togglePasswordVisibility('password')">
					<img :src="visible" alt="eye">
				</span>
			</div>

			<span class="forgot-password" @click="redirectTo(`/forgot-password`)">
				Forgot my password?
			</span>

			<div class="form-bottom">
				<span class="error" v-for="(error, index) in FORM_VALIDATOR?.errors()" :key="index">{{ error.fieldCondition.message }}</span>
				<input
					@submit="handleSubmit($event)"
					:class="['sign-in-button', {'not-allowed' : !FORM_VALIDATOR?.isFormValid() || (!formData.email && !formData.password)}]"
					type="submit"
					value="SIGN IN"
				>
			</div>

		</form>
	</div>
</template>

<script>
import loginMixin from "@/common/mixins/login-mixin";
import {FormValidator} from "@/common/services/FormValidator";
import {login} from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

export default {
	name: "GuestLogin",
	mixins: [loginMixin],
	data() {
		return {
			formData: {
				username: null,
				password: null
			},
			fieldsConditions: {
				username: {
					isRequired: {
						value: true,
						message: "The email is required."
					},
					pattern: {
						value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
						message: "The email does not match the required format."
					}
				},
				password: {
					minLength: {
						value: 3,
						message: 'The password must be at least 3 symbols'
					},
					maxLength: {
						value: 255,
						message: 'The password must not be more than 255 symbols'
					}
				}
			},
			FORM_VALIDATOR: null
		}
	},
	mounted() {
		this.FORM_VALIDATOR = new FormValidator(this.formData, this.fieldsConditions);
	},
	methods: {
		handleSubmit(event) {
			event.preventDefault();
			this.FORM_VALIDATOR.validateFormFields();

			if (this.FORM_VALIDATOR.isFormValid() && (this.formData.username && this.formData.password)) {
				this.$loader.show({
					text: '',
					description: '',
					buttonText: null,
					isBlue: false,
					onCancel: () => {
					}
				});

				login(this.formData, 'GUEST')
					.then((response) => {
						this.setJwt(response, false);
						this.addLoginStatistic();
					})
					.catch((error) => {
						console.error(error)
						this.showNotification(`${this.$t('notifications.loginFailed')}`, NOTIFICATION_TYPE.ERROR);
					})
					.finally(() => {
						setTimeout(() => {
							this.$loader.hide();
						}, 400)
					});
			}
		},
		addLoginStatistic() {
			const props = {
				action: STATISTIC_SERVICE.ACTIONS.COMMON.USER_LOGIN_GUEST,
				comment: JSON.stringify({
					email: this.$store.getters.getUser.email,
					fullName: this.$store.getters.getUser.fullName
				}),
				user: {id: this.$store.getters.getUser.id}
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.sign-in-form-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 80%;
	gap: 20px;

	@media (max-width: $tablet) {
		width: 100%;
		max-width: 480px;
		height: unset;
		padding: 0;
		margin: unset;
		gap: 30px;
	}

	.sign-in-form-title {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		gap: 20px;
		max-width: 480px;
		width: 100%;
		min-width: 250px;

		@media (max-width: $mobile) {
			min-width: unset;
		}

		button {
			width: 40px;
			height: 40px;
			padding: 8px;
			gap: 8px;
			cursor: pointer;
			background-color: #001929;
			border: 1px solid transparent;
			border-radius: 4px;

			&:hover {
				border: 1px solid #EBEBF52E;
			}
		}

		h2 {
			margin: 0;
			font-family: Tiempos Headline, serif;
			font-size: 24px;
			font-weight: 500;
			line-height: 34px;
			letter-spacing: 0.360px;
			text-align: left;
		}
	}

	.sign-in-form {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 15px;

		.sign-in-form-content {
			display: flex;
			flex-direction: column;
			gap: 2px;
			position: relative;

			label {
				font-family: Roboto, serif;
				font-size: 10px;
				font-weight: 400;
				line-height: 16px;
				text-align: left;
				color: #FCFCFE;
				text-transform: uppercase;
			}

			input {
				border: 2px solid transparent;
				gap: 12px;
				padding: 10px 35px 10px 12px;
				font-family: Roboto, serif;
				font-size: 15px;
				font-weight: 400;

				&:focus {
					border: 2px solid $color-hover-button;
					outline: none;
				}
			}

			.error-border {
				border: 2px solid rgba(201, 32, 40, 1);
			}

			.toggle-password {
				position: absolute;
				right: 10px;
				top: 50%;
				z-index: 2;
				cursor: pointer;

				img {
					height: 15px;
					width: 17px;

					&.visible {
						height: 17px;
						width: 16px;
					}
				}
			}
		}

		.forgot-password {
			color: $color-hover-button;
			cursor: pointer;
			font-family: Roboto, serif;
			font-size: 15px;
			font-weight: 400;
			line-height: 20px;
			text-align: left;
			text-decoration: underline;
			width: fit-content;
		}

		.form-bottom {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.error {
				position: relative;
				color: red;
				font-size: 12px;
			}

			.sign-in-button {
				background-color: $color-hover-button;
				min-height: 48px;
				padding: 10px 18px;
				gap: 12px;
				font-family: Roboto, serif;
				font-size: 17px;
				font-weight: 400;
				line-height: 22px;
				text-align: center;
				cursor: pointer;
				margin-top: 20px;
				margin-bottom: 20px;
				border: none;

				&.not-allowed {
					cursor: not-allowed;
				}
			}
		}

	}
}
</style>
